import { render, staticRenderFns } from "./mail_list.vue?vue&type=template&id=e047dcbc&scoped=true&"
import script from "./mail_list.vue?vue&type=script&lang=js&"
export * from "./mail_list.vue?vue&type=script&lang=js&"
import style0 from "./mail_list.vue?vue&type=style&index=0&id=e047dcbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e047dcbc",
  null
  
)

export default component.exports